import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userService } from '../services/userService';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import UserLanguageSwitcher from '../components/common/UserLanguageSwitcher';
import './MajesticCommon.css';
import MajesticSelect from '../components/common/MajesticSelect';

const AddBankCardPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        bankName: '',
        bankAccountNumber: '',
        bankAccountName: '',
        accountNumber: ''
    });



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const data = await userService.addBankCard(formData);
            if (data.success) {
                toast.success(t('bank_card_added', 'Bank card added successfully'));
                navigate('/my-bank-card');
            }
        } catch (error) {
            console.error('Failed to add bank card:', error);
            toast.error(error.message || t('error_adding_bank_card', 'Error adding bank card'));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="majestic-page-wrapper">
            <div className="majestic-header d-flex align-items-center px-3 py-3 justify-content-between">
                <div style={{ width: '40px' }}>
                    <i
                        className="bi bi-chevron-left text-white fs-4 cursor-pointer"
                        onClick={() => navigate(-1)}
                    ></i>
                </div>
                <h1 className="majestic-header-title flex-grow-1 text-center font-majestic">
                    {t('add_bank_card', 'ADD BANK CARD')}
                </h1>
                <div style={{ width: '40px' }} className="d-flex justify-content-end">
                    <UserLanguageSwitcher />
                </div>
            </div>

            <div className="majestic-container animate-slide-up">
                <div className="p-4 rounded-4 mb-4" style={{ background: 'rgba(252, 213, 53, 0.05)', border: '1px solid rgba(252, 213, 53, 0.1)' }}>
                    <div className="d-flex align-items-center gap-3">
                        <div className="p-2 rounded-3" style={{ background: 'rgba(252, 213, 53, 0.1)' }}>
                            <i className="bi bi-shield-lock-fill text-warning fs-4"></i>
                        </div>
                        <div>
                            <div className="text-white fw-bold">{t('secure_binding', 'Secure Binding')}</div>
                            <div className="text-secondary small">{t('secure_binding_desc', 'Your card details are encrypted and safe.')}</div>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    {/* Bank Name (Optional) */}
                    <div className="majestic-form-group">
                        <div className="majestic-label-row">
                            <span className="majestic-label-dot"></span>
                            <label htmlFor="bankName" className="majestic-label-text">{t('bank_name', 'BANK NAME')}</label>
                        </div>
                        <div className="majestic-input-wrapper">
                            <input
                                id="bankName"
                                type="text"
                                name="bankName"
                                className="form-control majestic-input-field"
                                placeholder={t('enter_bank_name', 'Enter bank name')}
                                value={formData.bankName}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Bank Account Number (Optional) */}
                    <div className="majestic-form-group mt-3">
                        <div className="majestic-label-row">
                            <span className="majestic-label-dot"></span>
                            <label htmlFor="bankAccountNumber" className="majestic-label-text">{t('bank_account_number', 'BANK ACCOUNT NUMBER')}</label>
                        </div>
                        <div className="majestic-input-wrapper">
                            <input
                                id="bankAccountNumber"
                                type="text"
                                name="bankAccountNumber"
                                className="form-control majestic-input-field"
                                placeholder={t('enter_bank_account_number', 'Enter bank account number')}
                                value={formData.bankAccountNumber}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Card Number (Required) */}
                    <div className="majestic-form-group mt-3">
                        <div className="majestic-label-row">
                            <span className="majestic-label-dot"></span>
                            <label htmlFor="accountNumber" className="majestic-label-text">
                                {t('card_number', 'CARD NUMBER')}
                                <span style={{ color: '#ff4d4d', marginLeft: '4px' }}>*</span>
                            </label>
                        </div>
                        <div className="majestic-input-wrapper">
                            <input
                                id="accountNumber"
                                type="text"
                                name="accountNumber"
                                className="form-control majestic-input-field"
                                placeholder={t('enter_card_number', '0000 0000 0000 0000')}
                                value={formData.accountNumber}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Cardholder Name (Required) */}
                    <div className="majestic-form-group mt-3 mb-4">
                        <div className="majestic-label-row">
                            <span className="majestic-label-dot"></span>
                            <label htmlFor="bankAccountName" className="majestic-label-text">
                                {t('cardholder_name', 'CARD HOLDER NAME')}
                                <span style={{ color: '#ff4d4d', marginLeft: '4px' }}>*</span>
                            </label>
                        </div>
                        <div className="majestic-input-wrapper">
                            <input
                                id="bankAccountName"
                                type="text"
                                name="bankAccountName"
                                className="form-control majestic-input-field"
                                placeholder={t('enter_cardholder_name', 'Enter Cardholder Name')}
                                value={formData.bankAccountName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={submitting}
                        className="btn majestic-btn-primary w-100 py-3 mt-2"
                    >
                        {submitting ? (
                            <><span className="spinner-border spinner-border-sm me-2"></span>{t('submitting', 'Processing...')}</>
                        ) : (
                            <><i className="bi bi-check2-circle me-2"></i>{t('save', 'SAVE')}</>
                        )}
                    </button>
                </form>

                <div className="mt-4 p-3 rounded-3" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.03)' }}>
                    <div className="text-secondary extra-small d-flex gap-2">
                        <i className="bi bi-info-circle text-warning"></i>
                        <span style={{ fontSize: '11px', lineHeight: '1.4' }}>
                            {t('binding_notice', 'Please ensure all details match your official records to avoid transaction delays.')}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddBankCardPage;
